import MetaBaseDashBoardSix from "../../features/MetabaseDashBoard/MetaBaseDashBoardSix"

const MetabaseReport5 = () => {
    return (
    <div><MetaBaseDashBoardSix/></div>
  )
}

export default MetabaseReport5